import { CPFInput } from 'components/Inputs/CPFInput';
import { TextInput } from 'components/Inputs/TextInput';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { IUserRole } from 'types/Auth';

import { Box, Grid, Typography } from '@mui/material';

import { LoginLink } from './LoginLink';

export const RequestRecoveryPasswordForm: FC = ({ children }) => {
  const { userRole } = useParams<{ userRole: IUserRole }>();

  return (
    <Box
      sx={{ height: '100%' }}
      alignContent="center"
      alignItems="center"
      justifyContent="space-evenly"
      display="flex"
      flexDirection="column"
      flex={1}
      py={4}
    >
      <Grid container spacing={2} sx={{ px: { xl: 12, lg: 8, md: 4, sm: 4 } }}>
        <Grid item container xs={12} justifyContent="center">
          <Typography
            component="h1"
            variant="h5"
            sx={{ fontWeight: 400, fontSize: 24 }}
          >
            Esqueceu sua senha?
          </Typography>

          {userRole === 'partner' || userRole === 'company' ? (
            <Typography mt={3} mb={4} textAlign="center">
              Não se preocupe! Insira o seu e-mail de cadastro e enviaremos
              instruções para você.
            </Typography>
          ) : (
            <Typography mt={3} mb={4} textAlign="center">
              Não se preocupe! Insira o seu CPF de cadastro e enviaremos
              instruções para você.
            </Typography>
          )}
        </Grid>

        <Grid item xs={12}>
          {userRole === 'partner' || userRole === 'company' ? (
            <TextInput name="email" id="email" label="E-mail" required />
          ) : (
            <CPFInput />
          )}
        </Grid>

        <Grid item xs={12}>
          {children}

          <LoginLink />
        </Grid>
      </Grid>
    </Box>
  );
};
